export const getInitialRecorderState = ({ audio, Beginning = 0, Waiting = 0 }) => ({
  currentTime: 0,
  initTimer: audio ? Beginning : 0,
  isPlayingAudio: Boolean(audio),
  timer: Waiting,
});
